import { render, staticRenderFns } from "./LoginFormBase.vue?vue&type=template&id=2c1bcc72"
import script from "./LoginFormBase.vue?vue&type=script&lang=js"
export * from "./LoginFormBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports